<template>
  <div>
    <div class="flex flex-wrap-reverse items-center mb-4">
      <!-- ACTION - DROPDOWN -->
      <vs-dropdown vx-trigger-click class="cursor-pointer mr-4">
        <div
          class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
        >
          <span v-if="selectedFilter" class="mr-2">
            {{
            selectedFilter.description
            }}
          </span>
          <span v-else class="mr-2">Filtrar</span>
          <feather-icon icon="ChevronDownIcon" sdvgClasses="h-2 w-2" />
        </div>

        <vs-dropdown-menu>
          <vs-dropdown-item
            @click="selectedFilter = filter"
            :key="filter.id"
            v-for="filter in filters"
          >
            <span>{{ filter.description }}</span>
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>

      <vs-dropdown
        v-if="selectedFilter && selectedFilter.type == 'dropdown'"
        vx-trigger-click
        class="cursor-pointer mr-4"
      >
        <div
          class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
        >
          <span class="mr-2">Seleccionar</span>
          <feather-icon icon="ChevronDownIcon" sdvgClasses="h-2 w-2" />
        </div>

        <vs-dropdown-menu>
          <vs-dropdown-item
            @click="addFilterOption(option)"
            :key="option.id"
            v-for="option in selectedFilter.options"
          >
            <span v-if="option.name">{{ option.name }}</span>
            <span v-else>{{ option.description }}</span>
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>

      <div
        v-if="selectedFilter && selectedFilter.type === 'input'"
        class="con-input-search vs-table--search m-0"
      >
        <input
          v-model="selectedFilter.value"
          v-on:keyup.enter="addFilterValue(selectedFilter.value)"
          class="input-search vs-table--search-input m-0 py-4"
          :type="selectedFilter.input_type"
          placeholder="Buscar.."
        />
        <i class="vs-icon notranslate icon-scale material-icons null">search</i>
      </div>

      <div v-if="selectedFilter && selectedFilter.type === 'date'">
        <div class="flex flex-row">
          <datepicker
            format="dd/MM/yyyy"
            class="datepicker mr-4"
            :disabled-dates="dateFromFilterDisabledDates"
            :language="es"
            placeholder="Seleccionar Fecha Desde"
            v-model="selectedFilter.from"
          ></datepicker>
          <datepicker
            :disabled="!selectedFilter.from"
            format="dd/MM/yyyy"
            class="datepicker"
            :disabled-dates="dateToFilterDisabledDates"
            :language="es"
            placeholder="Seleccionar Fecha Hasta"
            v-model="selectedFilter.to"
          ></datepicker>
        </div>
      </div>

      <vx-tooltip text="Aplicar filtro">
        <vs-button
          v-if="
                        selectedFilter &&
                           ( selectedFilter.value &&
                            selectedFilter.value.length > 2 &&
                            selectedFilter.type === 'input') || selectedFilter &&
                            selectedFilter.type === 'date' &&  selectedFilter.from &&  selectedFilter.to
                    "
          type="flat"
          size="default"
          @click="selectedFilter.type === 'date' ? addFilterDate(selectedFilter) : addFilterValue(selectedFilter.value)"
          icon-pack="feather"
          icon="icon-check-circle"
          color="success"
        ></vs-button>
      </vx-tooltip>

      <vx-tooltip text="Limpiar filtros">
        <vs-button
          v-if="filtersSelected.length > 0"
          type="flat"
          size="default"
          @click="clearFilters"
          icon-pack="feather"
          icon="icon-x-circle"
          color="danger"
        ></vs-button>
      </vx-tooltip>
    </div>
    <div v-if="filtersSelected" slot="filters" class="flex flex-wrap w-full">
      <vs-chip
        class="ml-6"
        :key="filter.filter.id"
        @click="removeFilter(filter)"
        v-for="filter in filtersSelected"
        closable
      >
        <span v-if="filter.filter.value">
          {{
          filter.filter | format_filter_value
          }}
        </span>
        <span v-else-if="filter.filter.from">
          {{
          filter.filter | format_filter_date
          }}
        </span>
        <span v-else-if="filter.option">
          {{
          filter | format_filter_option
          }}
        </span>
      </vs-chip>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { es } from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
export default {
  name: 'table-filter',
  props: {
    filters: {
      type: Array,
      required: true,
      default: []
    }
  },
  data() {
    return {
      es: es,
      selectedFilter: null,
      filtersSelected: []
    }
  },
  components: {
    Datepicker
  },
  computed: {
    dateToFilterDisabledDates() {
      return {
        to: new Date(this.selectedFilter.from),
        from: new Date()
      }
    },
    dateFromFilterDisabledDates() {
      return {
        from: new Date(this.selectedFilter.to)
      }
    }
  },
  methods: {

    clearFilters(){
      this.$emit('onClear');
      this.filtersSelected = []
    },

    removeFilter(filter) {
      this.filtersSelected = _.filter(this.filtersSelected, o => {
        return o.filter.id !== filter.filter.id
      })
      this.$emit('onFilter', this.filtersSelected)
    },
    // For type = dropdown
    addFilterOption(option) {
      this.filtersSelected.forEach(o => {
        if (o.filter.id === this.selectedFilter.id) {
          o.option = option
        }
      })

      let exist =
        _.filter(this.filtersSelected, o => {
          if (o.filter.id === this.selectedFilter.id) {
            return o.option.id === option.id
          }
          return false
        }).length > 0
      if (!exist) {
        this.filtersSelected.push({
          filter: this.selectedFilter,
          option: option
        })
      }
      this.$emit('onFilter', this.filtersSelected)
    },
    // For type = date
    addFilterDate(filter) {
      let exist = false
      let from
      this.selectedFilter.from = moment(filter.from).format()
      this.selectedFilter.to = moment(filter.to).format()
      this.filtersSelected.forEach(o => {
        if (o.filter.id === this.selectedFilter.id) {
          exist = true
          o.filter.from = moment(filter.from).format()
          o.filter.to = moment(filter.to).format()
          console.log('Filter formatted', o.filter.from)
        }
      })
      if (!exist) {
        this.filtersSelected.push({
          filter: Object.assign({}, this.selectedFilter)
        })
      }
      this.$emit('onFilter', this.filtersSelected)
    },
    // For type = input
    addFilterValue(value) {
      let exist = false
      this.filtersSelected.forEach(o => {
        if (o.filter.id === this.selectedFilter.id) {
          exist = true
          o.filter.value = value
        }
      })

      if (!exist) {
        this.filtersSelected.push({
          filter: Object.assign({}, this.selectedFilter)
        })
      }
      this.$emit('onFilter', this.filtersSelected)
    }
  },
  filters: {
    format_filter_date(filter) {
      if (!filter.from || !filter.to) return ''
      const from = moment(filter.from).format('L')
      const to = moment(filter.to).format('L')
      return `${filter.description} - Desde ${from} - Hasta ${to}`
    },
    format_filter_value(filter) {
      if (!filter) return 'No definido'
      return `${filter.description} - ${filter.value}`
    },
    format_filter_option(filter) {
      if (!filter) return 'No definido'
      return `${
        filter.filter.description
          ? filter.filter.description
          : filter.filter.name
      } - ${
        filter.option.description
          ? filter.option.description
          : filter.option.name
      }`
    }
  }
}
</script>

<style lang="scss">
.datepicker {
  z-index: 999;
}
</style>